/* eslint-disable default-param-last */
import {
  SET_CERT_LIST_CAMPAIGN_INFO,
  SET_CERT_LIST_CURRENT_ACTION,
  SET_CERT_LIST_HAS_ADMIN_ROLE,
  SET_CERT_LIST_HAS_AUDITOR_LOGGED_IN,
  SET_CERT_LIST_IS_CONSULTEE_LOGIN,
  SET_CERT_LIST_IS_FIRST_LIST_LOAD_FINISHED,
  SET_CERT_LIST_IS_PAGE_LOAD_FINISHED,
  SET_CERT_LIST_IS_RELOAD_REQUIRED,
  SET_CERT_LIST_OFFSET,
  SET_CERT_LIST_ONE_TILE_ACTIONABLE,
  SET_CERT_LIST_RECENT_DATA,
  SET_CERT_LIST_TOTAL_ITEMS_COUNT,
  SET_CERT_LIST_TRANSITION_ID,
  SET_PREDEFINED_COMMENTS,
} from '../types';

const INITIAL_STATE = {
  totalItems: 0,
  listOffset: 0,
  isPageLoadFinished: false,
  recentListData: null,
  isFirstListLoadFinished: false,
  isReloadRequired: false,
  predefinedComments: {},
  isAdminLogin: false,
  hasAuditorLoggedIn: false,
  isConsulteeLogin: null,
  transitionTileId: null,
  currentAction: null,
  isAtleastOneTileActionable: true,
  campaignInfo: {
    campaignName: null,
    campaignType: null,
    startDate: null,
    endDate: null,
    autoRevoke: null,
    campaignOwnerName: null,
  },
};

const coreReducer = (state = INITIAL_STATE, action) => {
  switch (action?.type) {
    case SET_CERT_LIST_TOTAL_ITEMS_COUNT:
      return {
        ...state,
        totalItems: action?.payload,
      };

    case SET_CERT_LIST_IS_PAGE_LOAD_FINISHED:
      return {
        ...state,
        isPageLoadFinished: action?.payload,
      };

    case SET_CERT_LIST_RECENT_DATA:
      return {
        ...state,
        recentListData: action?.payload,
      };

    case SET_CERT_LIST_IS_FIRST_LIST_LOAD_FINISHED:
      return {
        ...state,
        isFirstListLoadFinished: action?.payload,
      };

    case SET_CERT_LIST_IS_RELOAD_REQUIRED:
      return {
        ...state,
        isReloadRequired: action?.payload,
      };
    case SET_CERT_LIST_OFFSET:
      return {
        ...state,
        listOffset: action.payload,
      };

    case SET_CERT_LIST_HAS_ADMIN_ROLE:
      return {
        ...state,
        isAdminLogin: action?.payload,
      };
    case SET_CERT_LIST_HAS_AUDITOR_LOGGED_IN:
      return {
        ...state,
        hasAuditorLoggedIn: action?.payload,
      };

    case SET_CERT_LIST_IS_CONSULTEE_LOGIN:
      return {
        ...state,
        isConsulteeLogin: action?.payload,
      };

    case SET_CERT_LIST_ONE_TILE_ACTIONABLE:
      return {
        ...state,
        isAtleastOneTileActionable: action?.payload,
      };

    case SET_CERT_LIST_CAMPAIGN_INFO:
      return {
        ...state,
        campaignInfo: action.payload,
      };

    case SET_PREDEFINED_COMMENTS:
      return {
        ...state,
        predefinedComments: {
          ...state.predefinedComments,
          [action.payload.certKey]: action.payload.comments,
        },
      };

    case SET_CERT_LIST_TRANSITION_ID:
      return {
        ...state,
        transitionTileId: action?.payload,
      };
    case SET_CERT_LIST_CURRENT_ACTION:
      return {
        ...state,
        currentAction: action?.payload,
      };

    default:
      return state;
  }
};

export default coreReducer;
